import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CreditCard,
  Database,
  FolderGit2,
  LayoutDashboard,
  LayoutTemplate,
  MessageSquareText,
  Monitor,
  type LucideIcon,
} from 'lucide-react';

export type NavItem = {
  path: string;
  label: string;
  icon: LucideIcon;
  exact?: boolean;
};

export function useDesktopNavItems(): NavItem[] {
  const { t } = useTranslation('nav');
  return useMemo(
    () => [
      { path: '/', label: t('dashboard'), icon: LayoutDashboard, exact: true },
      { path: '/projects', label: t('projects'), icon: FolderGit2 },
      { path: '/sessions', label: t('sessions'), icon: Monitor },
      { path: '/databases', label: t('databases'), icon: Database },
      {
        path: '/templates',
        label: t('templateMarketplace'),
        icon: LayoutTemplate,
      },
    ],
    [t],
  );
}

export function useMobileNavItems(): NavItem[] {
  const { t } = useTranslation('nav');
  return useMemo(
    () => [
      { path: '/', label: t('home'), icon: LayoutDashboard, exact: true },
      { path: '/projects', label: t('projects'), icon: FolderGit2 },
      { path: '/talk', label: t('talk'), icon: MessageSquareText },
      { path: '/sessions', label: t('sessions'), icon: Monitor },
      {
        path: '/templates',
        label: t('templateMarketplace'),
        icon: LayoutTemplate,
      },
      { path: '/billing/usage', label: t('billing'), icon: CreditCard },
    ],
    [t],
  );
}
